module.exports = __webpack_public_path__ + "static/assets/6c037268777f4b85658c4fdc1f55b4f9.svg";